import DashboardIcon from "@material-ui/icons/Dashboard";
import PlaylistAddIcon from "@material-ui/icons/PlaylistAdd";
import SupervisorAccountIcon from "@material-ui/icons/SupervisorAccount";
import SettingsIcon from "@material-ui/icons/Settings";
import AssessmentIcon from "@material-ui/icons/Assessment";
import LoyaltyIcon from "@material-ui/icons/Loyalty";
import ShowChartIcon from "@material-ui/icons/ShowChart";
import GroupAddIcon from "@mui/icons-material/GroupAdd";
import ExpenseIcon from "../../assets/icons/ExpenseIcon";
// import PrintIcon from "@material-ui/icons/Print";
import { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { withRouter } from "../../utils/withRouter";
import { BellFilled } from "@ant-design/icons";
import ViewOrder from "../../assets/icons/order-food.png";
import CurrencyExchangeIcon from "@mui/icons-material/CurrencyExchange";
import { Dropdown, Menu } from "antd";
import { CaretDownOutlined } from "@ant-design/icons";
import { CircularProgress } from "@material-ui/core";
import useLocalStoage from "../../hooks/useLocalstorage";
// import { useHotkeys } from "react-hotkeys-hook";
import Loader from "../loader";

const initialState = {
  overView: false,
  reports: false,
  items: false,
  cm: false,
  settings: false,
  support: false,
  loyalty: false,
  stockValue: false,
  employee: false,
  purchaseOrder: false,
  vm: false,
  subscription: false,
  orderDisplay: false,
  cashManagement: false,
  expensesManagement: false,
};

let locationChanges = [];
const SideMenu = (props) => {
  const shopProfile = useSelector((state) => state.shopDetails);
  const settings = useSelector((state) => state.settings.settings);
  const outlets = useSelector((state) => state.outlets.outlets);
  const [selected, setSelected] = useState(initialState);
  const [shopDetails, setShopDetails] = useState({});
  const [outletArray, setOutletArray] = useState([]);
  const [selectedOutlet, setSelectedOutlet] = useState();
  const [loading, setLoading] = useState(false);
  const [mainUserShopDetails, setMainUserShopDetails] = useLocalStoage(
    "mainUserShopDetails",
    []
  );
  const dispatch = useDispatch();

  // useHotkeys("ctrl+F1", () => props.history.push("/dashboard"), ["ctrl"]);
  // useHotkeys("ctrl+F2", () => props.history.push("/billing"), ["ctrl"]);
  // useHotkeys("ctrl+F3", () => props.history.push("/dashboard/shop-items"), [
  //   "ctrl",
  // ]);
  // useHotkeys("ctrl+F7", () => props.history.push("/dashboard/reports"), [
  //   "alt",
  // ]);
  // useHotkeys(
  //   "ctrl+F8",
  //   () => props.history.push("/dashboard/stock-value-report"),
  //   ["alt"]
  // );
  // useHotkeys("ctrl+F9", () => props.history.push("/dashboard/loyalty"), [
  //   "ctrl",
  // ]);
  // useHotkeys(
  //   "ctrl+F10",
  //   () => props.history.push("/dashboard/customer-management"),
  //   ["ctrl"]
  // );
  // useHotkeys(
  //   "ctrl+F11",
  //   () => props.history.push("/dashboard/vendor-management"),
  //   ["ctrl"]
  // );
  // // useHotkeys('ctrl+F10', () =>  props.history.push("/dashboard/cash-management"), ['ctrl'])
  // useHotkeys(
  //   "ctrl+F12",
  //   () => props.history.push("/dashboard/employeeAccess"),
  //   ["ctrl"]
  // );
  // useHotkeys("alt+F12", () => props.history.push("/dashboard/settings"), [
  //   "ctrl",
  // ]);

  // useEffect(() => {
  //   function keydownHandler(event) {
  //     // event.stopPropagation();
  //     // event.preventDefault();
  //     if (event.ctrlKey && event.key == "F2") {
  //       props.history.push("/dashboard");
  //     } else if (event.ctrlKey && event.key == "F3") {
  //       if (shopData.shopType === "Restaurant") {
  //         props.history.push("/kitchen-billing");
  //       } else {
  //         props.history.push("/billing");
  //       }
  //     } else if (event.ctrlKey && event.key == "F4") {
  //       props.history.push("/dashboard/shop-items");
  //     } else if (event.ctrlKey && event.key == "F5") {
  //       props.history.push("/dashboard/reports");
  //     } else if (event.ctrlKey && event.key == "F6") {
  //       props.history.push("/dashboard/stock-value-report");
  //     } else if (event.ctrlKey && event.key == "F7") {
  //       props.history.push("/dashboard/loyalty");
  //     } else if (event.ctrlKey && event.key == "F8") {
  //       props.history.push("/dashboard/customer-management");
  //     } else if (event.ctrlKey && event.key == "F9") {
  //       props.history.push("/dashboard/vendor-management");
  //     }else if (event.ctrlKey && event.key == "F10") {
  //       props.history.push("/dashboard/cash-management");
  //     } else if (event.ctrlKey && event.key == "F11") {
  //       props.history.push("/dashboard/employeeAccess");
  //     } else if (event.ctrlKey && event.key == "F12") {
  //       props.history.push("/dashboard/settings");
  //     }
  //   }
  //   document.addEventListener("keydown", keydownHandler);
  //   return () => {
  //     window.removeEventListener("keydown", keydownHandler);
  //   };
  // }, []);
  useEffect(() => {
    setSelected({
      ...initialState,
      [props.on]: true,
    });
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  useEffect(() => {
    setShopDetails(shopProfile);
  }, [shopProfile]);

  useEffect(() => {
    if (outlets) {
      setOutletArray(outlets);
    }
  }, [outlets]);

  const handleOutLetClick = (v) => {
    locationChanges.push({
      ...shopProfile,
      userId: shopProfile.shopId,
      settings: settings,
      userPhoneNumber: shopProfile.phoneNumber,
    });
    setLoading(true);
    setSelectedOutlet(v.key);
    const outletData = outlets.find((i) => i.userId === v.key);
    let updatedShopDetails = {};
    if (v.key === "main") {
      updatedShopDetails = {
        ...shopProfile,
        outletArea: undefined,
        outletState: undefined,
        shopAddress: mainUserShopDetails[0].shopAddress,
        userId: mainUserShopDetails[0].userId
          ? mainUserShopDetails[0].userId
          : mainUserShopDetails[0].shopId,
        userId10Digit: mainUserShopDetails[0].userId10Digit,
        userPincode: mainUserShopDetails[0].userPincode,
        categoryList: mainUserShopDetails[0].categoryList,
        taxMaster: mainUserShopDetails[0].taxMaster,
        userPhoneNumber: mainUserShopDetails[0].userPhoneNumber,
      };
      setMainUserShopDetails([]);
      locationChanges = [];
      dispatch({
        type: "SET_SETTINGS",
        payload: mainUserShopDetails[0].settings,
      });
      setSelectedOutlet({});
    } else {
      updatedShopDetails = {
        ...shopProfile,
        shopAddress: outletData.shopAddress,
        outletArea: outletData.outletArea,
        outletState: outletData.outletState,
        userId: outletData.userId,
        userId10Digit: outletData.userId10Digit,
        userPincode: outletData.userPincode,
        categoryList: outletData.categoryList,
        taxMaster: outletData.taxMaster,
        userPhoneNumber: shopProfile.phoneNumber,
      };
      const data = {
        ...shopProfile,
        shopAddress: outletData.shopAddress,
        outletArea: outletData.outletArea,
        outletState: outletData.outletState,
        userId: outletData.userId,
        userId10Digit: outletData.userId10Digit,
        userPincode: outletData.userPincode,
        categoryList: outletData.categoryList,
        taxMaster: outletData.taxMaster,
        settings: outletData.settings,
      };
      locationChanges.push(data);
      setMainUserShopDetails(locationChanges);
      dispatch({
        type: "SET_SETTINGS",
        payload: outletData.settings,
      });
    }
    dispatch({
      type: "SET_SHOP_PROFILE",
      payload: updatedShopDetails,
    });
    props.history.push("/dashboard/overview");
    setTimeout(() => {
      setLoading(false);
    }, [1000]);
  };

  const menu = () => {
    return (
      <Menu className="sideMenu" onClick={handleOutLetClick}>
        <>
          {mainUserShopDetails.length > 0 && (
            <Menu.Item
              style={{
                width: "250px",
                height: 44,
              }}
              key={"main"}
            >
              Main
            </Menu.Item>
          )}
          {outletArray.map((data) => (
            <Menu.Item
              style={{
                width: "250px",
              }}
              key={data.userId}
            >
              {data.outletArea ? data.outletArea : data.shopAddress}
            </Menu.Item>
          ))}
        </>
      </Menu>
    );
  };

  return (
    <div className="sidemenu-wrapper">
      {loading && (
        <div
          style={{
            position: "fixed",
            top: "40%",
            left: "50%",
            transform: "translate(45%,-50%)",
            zIndex: 10000,
          }}
        >
          <Loader size={56} />
        </div>
      )}

      <div
        className="sideMenuLogo"
        onClick={() => props.history.push("/dashboard/overview")}
      >
        <h3>Ghoshak Billing</h3>
      </div>
      <div className="shop-profile">
        <div className="image-div">
          <img
            src={
              shopDetails.shopImageLocation !== "removed"
                ? shopDetails.shopImageLocation
                : "https://via.placeholder.com/300/ef4667/FFFFFF?text=GHOSHAK"
            }
            width="70px"
            height="70px"
            className="profileImage"
            alt="shop-profile"
          />
        </div>
        <div
          className="shop-details"
          style={{
            position: "relative",
          }}
        >
          <div>
            {shopDetails.userType === "Shop" && (
              <>
                {outlets?.length > 0 ? (
                  <Dropdown
                    getPopupContainer={(el) => el.parentNode}
                    overlay={menu}
                    placement="bottom"
                    arrow
                  >
                    <div>
                      <h5>
                        {shopDetails.shopName}{" "}
                        <CaretDownOutlined
                          style={{
                            fontSize: "1rem",
                            cursor: "pointer",
                            position: "absolute",
                            top: "50%",
                            right: "4px",
                            transform: "translateY(-100%)",
                          }}
                        />
                      </h5>
                      {shopDetails?.outletArea && (
                        <p className="text-muted">
                          {shopDetails?.outletArea}, {shopDetails?.outletState}
                        </p>
                      )}
                      {!selectedOutlet && (
                        <p>Shop Id: {shopDetails.userId10Digit}</p>
                      )}
                    </div>
                  </Dropdown>
                ) : (
                  <div>
                    <h5>{shopDetails.shopName} </h5>
                    {shopDetails?.outletArea && (
                      <p className="text-muted">
                        {shopDetails?.outletArea}, {shopDetails?.outletState}
                      </p>
                    )}
                    <p>Shop Id: {shopDetails.userId10Digit}</p>
                  </div>
                )}
              </>
            )}
          </div>

          {["Outlet", "Employee"].includes(shopDetails.userType) && (
            <div>
              <h5>{shopDetails.shopName}</h5>
              {shopDetails?.outletArea && (
                <p className="text-muted">
                  {shopDetails?.outletArea}, {shopDetails?.outletState}
                </p>
              )}
              {!selectedOutlet && (
                <p
                  style={{
                    fontSize: "14px",
                    marginTop: "-6px",
                  }}
                >
                  Shop Id: {shopDetails.userId10Digit}
                </p>
              )}
            </div>
          )}
        </div>
      </div>
      {selectedOutlet && (
        <p
          style={{
            paddingLeft: "5.5rem",
            fontSize: 14,
            marginTop: "-4px",
          }}
        >
          Shop Id: {shopDetails.userId10Digit}
        </p>
      )}

      <div className="page-links">
        <div className="links">
          <p
            className={selected.overView ? "selected" : "not-selected"}
            onClick={() => {
              props.history.push("/dashboard/overview");
            }}
          >
            {<DashboardIcon style={{ marginTop: "-4px" }} />} Dashboard
          </p>
        </div>

        <div className="links">
          <p
            className={selected.items ? "selected" : "not-selected"}
            onClick={() => {
              props.history.push("/dashboard/shop-items");
            }}
          >
            {<PlaylistAddIcon style={{ marginTop: "-4px" }} />} Shop Items
          </p>
        </div>

        <div className="links">
          <p
            className={selected.reports ? "selected" : "not-selected"}
            onClick={() => {
              props.history.push("/dashboard/reports");
            }}
          >
            {<AssessmentIcon style={{ marginTop: "-4px" }} />} Reports
          </p>
        </div>

        <div className="links">
          <p
            className={selected.stockValue ? "selected" : "not-selected"}
            onClick={() => {
              props.history.push("/dashboard/stock-value-report");
            }}
          >
            {<ShowChartIcon style={{ marginTop: "-4px" }} />} Stock Value Report
          </p>
        </div>

        <div className="links">
          <p
            className={selected.loyalty ? "selected" : "not-selected"}
            onClick={() => {
              props.history.push("/dashboard/loyalty");
            }}
          >
            {<LoyaltyIcon style={{ marginTop: "-4px" }} />} Loyalty Points
          </p>
        </div>

        <div className="links">
          <p
            className={selected.cm ? "selected" : "not-selected"}
            onClick={() => {
              props.history.push("/dashboard/customer-management");
            }}
          >
            {<SupervisorAccountIcon style={{ marginTop: "-4px" }} />} Customer
            Management
          </p>
        </div>

        <div className="links">
          <p
            className={selected.vm ? "selected" : "not-selected"}
            onClick={() => {
              props.history.push("/dashboard/vendor-management");
            }}
          >
            {<GroupAddIcon style={{ marginTop: "-4px" }} />} Vendor management
          </p>
        </div>

        <div className="links">
          <p
            className={
              selected.expensesManagement ? "selected" : "not-selected"
            }
            onClick={() => {
              props.history.push("/dashboard/expenses-management");
            }}
            style={{
              display: "flex",

              alignItems: "center",
              gap: "4px",
            }}
          >
            <ExpenseIcon
              color={selected.expensesManagement ? "#ef4667" : "#000"}
              className={
                selected.expensesManagement ? "selected" : "not-selected"
              }
            />
            <span>Expenses Management</span>
          </p>
        </div>

        <div className="links">
          <p
            className={selected.subscription ? "selected" : "not-selected"}
            onClick={() => {
              props.history.push("/dashboard/subscription");
            }}
          >
            {<BellFilled style={{ marginTop: "-4px", fontSize: "1.5rem" }} />}{" "}
            Subscription
          </p>
        </div>

        <div className="links">
          <p
            className={selected.orderDisplay ? "selected" : "not-selected"}
            onClick={() => {
              props.history.push("/dashboard/order-display");
            }}
          >
            <img
              src={ViewOrder}
              alt="view-order"
              width={30}
              height={30}
              style={{ marginTop: "-2x", fontSize: "1.5rem" }}
            />
            Orders
          </p>
        </div>

        <div className="links">
          <p
            className={selected.cashManagement ? "selected" : "not-selected"}
            onClick={() => {
              props.history.push("/dashboard/cash-management");
            }}
          >
            {<CurrencyExchangeIcon style={{ marginTop: "-4px" }} />} Counter
            opening/closing
          </p>
        </div>

        <div className="links">
          <p
            className={selected.employee ? "selected" : "not-selected"}
            onClick={() => {
              props.history.push("/dashboard/employeeAccess");
            }}
          >
            {<SupervisorAccountIcon style={{ marginTop: "-4px" }} />} Employee
            Access
          </p>
        </div>

        <div className="links">
          <p
            className={selected.settings ? "selected" : "not-selected"}
            onClick={() => {
              props.history.push("/dashboard/settings");
            }}
          >
            {<SettingsIcon style={{ marginTop: "-4px" }} />} Settings
          </p>
        </div>
        {/* <div className="links">
          <p
            className={selected.support ? "selected" : "not-selected"}
            onClick={() => {
              props.history.push("/dashboard/support");
            }}
          >
            {<SupportAgent style={{ marginTop: "-4px" }} />} Support
          </p>
        </div> */}
      </div>
    </div>
  );
};

export default withRouter(SideMenu);
